import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setScheduleEvent,
  clearScheduleEvent,
} from "../../store/patient/scheduleEventSlice";

export const useScheduleEventStore = () => {
  const dispatch = useDispatch();

  const { scheduleEvents, scheduleEvent } = useSelector(
    (state) => state.patient.scheduleEvent
  );

  const handleSetScheduleEvent = useCallback(
    (scheduleEvent) => {
      dispatch(setScheduleEvent(scheduleEvent));
    },
    [dispatch]
  );

  const handleClearScheduleEvent = useCallback(() => {
    dispatch(clearScheduleEvent());
  }, [dispatch]);

  return {
    // Props
    scheduleEvents,
    scheduleEvent,

    // Methods
    handleSetScheduleEvent,
    handleClearScheduleEvent,
  };
};
